import { render, staticRenderFns } from "./DialogHistorial.vue?vue&type=template&id=345cca4a&"
import script from "./DialogHistorial.vue?vue&type=script&lang=js&"
export * from "./DialogHistorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports